<template>
  <div id="manager-staff">
    <div class="table-add">
      <el-button
        @click="openStaffDialog(-1, 'info')"
        size="medium"
        type="primary"
        >新增员工</el-button
      >
    </div>
    <div class="table-container">
      <el-table :data="staffList" stripe style="width: 100%">
        <el-table-column prop="user_name" label="工号"> </el-table-column>
        <el-table-column prop="real_name" label="姓名"> </el-table-column>
        <el-table-column prop="company_name" label="所属公司">
        </el-table-column>
        <el-table-column prop="foreign_name" label="英文名"> </el-table-column>
        <el-table-column prop="phone_num" label="电话号码"> </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            {{ GENDER_STATUS[scope.row.gender] }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建日期" width="180">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag size="small">{{ STAFF_STATUS[scope.row.status] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="openStaffDialog(scope.row.id, 'info')"
              type="primary"
              >编辑</el-button
            >
            <el-button
              size="small"
              @click="openStaffDialog(scope.row.id, 'salary')"
              type="primary"
              >薪资管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          small
          layout="prev, pager, next"
          :total="total_count"
          :current-page="page"
          @current-change="getStaffList"
        >
        </el-pagination>
      </div>
    </div>
    <staffInfo
      :staffDialogType.sync="staffDialogType"
      :staffId="showStaffId"
      @updateStaffList="getStaffList"
    />
    <staffSalary
      :staffDialogType.sync="staffDialogType"
      :staffId="showStaffId"
    />
  </div>
</template>

<script>
import { managerStaffList } from '@/api/manager'
import staffInfo from './components/info'
import staffSalary from './components/salary'
export default {
  name: 'manager-staff',
  components: {
    staffInfo,
    staffSalary,
  },
  data() {
    return {
      total_count: 0,
      page: 1,
      staffList: [],
      staffDialogType: '', //info员工信息,salary薪资信息
      showStaffId: '',
    }
  },
  mounted() {
    this.getStaffList()
  },
  methods: {
    async getStaffList(_page = 1) {
      this.page = _page
      let { code, result } = await managerStaffList({ page: this.page })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.staffList = result.list
        this.total_count = result.total_count
      }
    },
    openStaffDialog(_id, _type) {
      this.showStaffId = _id
      this.staffDialogType = _type
    },
  },
}
</script>

<style lang="less" scoped>
.table-container {
  width: 100%;
}
.table-add {
  margin: 7px 0 15px 0;
}
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
.table-page {
  margin-top: 15px;
  text-align: center;
}
</style>
